// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"0d45d072","30":"86ed7e1d","151":"2e381dac","153":"f1100750","238":"4389178f","276":"4acd5edb","558":"bfdcba28","728":"5dd62049","745":"1fbf0e01","761":"bed9dc7d","776":"d991951d","779":"58cff79f","872":"95624860","984":"84fd960c"}[chunkId] + ".chunk.js";
};